import { PersonalDataRequestStatusEnum } from '../enums/personal-data-request-status.enum';
import { AccessToken } from './access-token.model';
import { ResultFile } from './result-file.model';
import { User } from './user.model';

export class Request {
    accessToken: AccessToken;
    contactAddress: {
        email: string;
        isVerified: boolean;
    };
    createdBy: User;
    creationTime: string;
    id: number;
    internalReference: string;
    portalId: number;
    requestedBy: string;
    resultFiles: ResultFile[];
    status: PersonalDataRequestStatusEnum;
}
